<script setup>
import { useDetectDevice } from '@/composables/device'

import EquipmentsView from '@/components/planner/EquipmentsView.vue'
import EquipmentsGrid from '@/components/planner/EquipmentsGrid.vue'

const { isMobile } = useDetectDevice()

</script>
<template>
  <equipments-view v-if="isMobile" />
  <equipments-grid v-else />
</template>
